import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Settings from '@/components/settings/Settings'
import store from './store'
import AllCustomers from './components/settings/customer/AllCustomers'
import EditCustomer from './components/settings/customer/EditCustomer'
import CustomerAccounts from './components/settings/customer/CustomerAccounts'
import CreateCustomer from './components/settings/customer/CreateCustomer'
import CreateAccount from './components/settings/account/CreateAccount'
import EditReport from './components/report/EditReport'

// Hide the redundant error message
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {name: 'current'}
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login')
    },
    {
      path: '/set-password/:code',
      name: 'SetPassword',
      component: () => import('./components/password/SetPassword')
    },
    {
      path: '/app',
      component: Main,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.loggedIn) {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: '',
          component: () => import('@/components/main/CurrentReports')
        },
        {
          path: 'current',
          name: 'current',
          component: () => import('@/components/main/CurrentReports')
        },
        {
          path: 'new',
          name: 'new-report',
          component: EditReport
        },
        {
          path: 'edit/:reportId?',
          name: 'edit-report',
          component: EditReport
        },
        {
          path: 'categories',
          name: 'report-categories',
          component: () => import('@/components/report-category/ReportCategories')
        },
        {
          path: 'tenant/self',
          name: 'self-tenant-edit',
          component: () => import('@/components/tenants/SelfTenantEdit')
        },
        {
          path: 'global',
          name: 'global-overview',
          component: () => import('@/components/tenants/GlobalOverview')
        },
        {
          path: 'global/customers',
          name: 'global-customers',
          component: () => import('@/components/tenants/GlobalCustomers')
        },
        {
          path: 'global/accounts',
          name: 'global-accounts',
          component: () => import('@/components/tenants/GlobalAccounts')
        },
        {
          path: 'global/accounts/create',
          name: 'create-global-account',
          component: () => import('@/components/tenants/CreateGlobalAccount')
        },
        {
          path: 'global/accounts/:id/edit',
          name: 'edit-global-account',
          component: () => import('@/components/tenants/EditGlobalAccount')
        },
        {
          path: 'global/servers',
          name: 'global-servers',
          component: () => import('@/components/settings/ServerSettings')
        },
        {
          path: 'global/customers/:id/edit',
          name: 'edit-global-customer',
          component: () => import('@/components/settings/customer/EditCustomer')
        },
        {
          path: 'global/customers/:id/accounts',
          name: 'global-customer-accounts',
          component: () => import('@/components/settings/customer/CustomerAccounts')
        },
        {
          path: 'tenants',
          component: () => import('@/components/tenants/Tenants'),
          children: [
            {
              path: '',
              name: 'tenants',
              component: () => import('@/components/tenants/AllTenants')
            },
            {
              path: 'create',
              name: 'create-tenant',
              component: () => import('@/components/tenants/CreateTenant')
            },
            {
              path: ':id/edit',
              name: 'edit-tenant',
              component: () => import('@/components/tenants/EditTenant')
            },
            {
              path: ':id/accounts',
              name: 'tenant-accounts',
              component: () => import('@/components/tenants/TenantAccounts')
            },
            {
              path: ':id/customers',
              name: 'tenant-customers',
              component: () => import('@/components/tenants/TenantCustomers')
            },
            {
              path: ':id/customers/create',
              name: 'create-tenant-customer',
              component: () => import('@/components/tenants/CreateTenantCustomer')
            },
            {
              path: ':id/customers/:customerId/edit',
              name: 'edit-tenant-customer',
              component: () => import('@/components/tenants/EditTenantCustomer')
            },
            {
              path: ':id/customers/:customerId/accounts',
              name: 'tenant-customer-accounts',
              component: () => import('@/components/tenants/TenantCustomerAccounts')
            },
            {
              path: ':id/customers/:customerId/accounts/create',
              name: 'create-tenant-customer-account',
              component: () => import('@/components/tenants/CreateTenantCustomerAccount')
            },
            {
              path: ':id/customers/:customerId/accounts/:accountId',
              name: 'edit-tenant-customer-account',
              component: () => import('@/components/tenants/EditTenantCustomerAccount')
            }
          ]
        },
        {
          path: 'server-settings',
          name: 'server-settings',
          component: () => import('@/components/settings/ServerSettings')
        },
        {
          path: 'settings',
          component: Settings,
          children: [
            {
              path: '',
              name: 'overview',
              component: AllCustomers
            },
            {
              path: ':id/edit',
              name: 'edit-customer',
              component: EditCustomer
            },
            {
              path: ':id/accounts',
              name: 'customer-accounts',
              component: CustomerAccounts
            },
            {
              path: ':id/accounts/:accountId',
              name: 'edit-account',
              component: CreateAccount
            },
            {
              path: ':id/account/create',
              name: 'create-account',
              component: CreateAccount
            },
            {
              path: 'customer/create',
              name: 'create-customer',
              component: CreateCustomer
            },
          ]
        },
      ]
    },
    {
      path: '*',
      redirect: 'app'
    },
  ]
})
